export default interface AIRepository {
    getAISumaries: (params: string, channel: string) => Promise<any>;
    getAIChats: (params: string) => Promise<any>;
    getAIChat: (chatId: string) => Promise<any>;
    getAIChatParsedFiles: (chatId: string, body?: any) => Promise<any>;
    getAIS3RagPath: (filename: string, customer: string) => Promise<any>;
    getAIS3RagRegisteredPath: (s3_key: string, customer: string) => Promise<any>;
    GetS3RagListByCustomer: (customer: string) => Promise<any>;
    DeleteS3RagDocument: (customer: string, document: string) => Promise<any>;
    getAISumaryByRecord: (record: string, channel: string) => Promise<any>;
    getNewAIEvaluation: (record: string) => Promise<any>;
    updateAISumaryByRecord: (record: string, content: any, channel: string) => Promise<any>;
    UpdateAISummaryInDisputeByRecord: (record: string, params: any) => Promise<any>;
    UpdateAISummaryInDisputeCommentsByRecord: (record: string, params: any) => Promise<any>;
    UpdateAISwapByRecord: (record: string, params: any) => Promise<any>;
    GetAISummaryInDisputeCommentsByRecord: (record: string) => Promise<any>;
    getAIEmbedURL: (dashboardName: string) => Promise<any>;
    searchAISummaries: (query: any) => Promise<any>;
    searchAISummariesLanguages: () => Promise<any>;
    searchAISummariesEntities: () => Promise<any>;
    searchAISummariesByTranscription: (params: any) => Promise<any>;
    getAIAgents: (customer: string, lob: string, channel: string) => Promise<any>;
    getAICustomers: (channel: string) => Promise<any>;
    getAIPerson: (query: any, type: string, params: string) => Promise<any>;
    getAIChatsByCustomer: (query: any, type: string, params: string) => Promise<any>;
    getAIEmailsByCustomer: (query: any, type: string, params: string) => Promise<any>;
    getAIMoments: (keywords: string[], page: number, type: string, customer: string, lob: string, channel: string) => Promise<any>;
    GetAIMomentsOptions: () => Promise<any>;
    UpdateAIMomentById: (content: any, keyword_id: number, value: any | undefined) => Promise<any>;
    CreateAIMoment: (customer: string, lob: string, type: string, description: string, weight: number, options: string, sec_response: string, channel: string) => Promise<any>;
    DeleteAIMoment: (keyword_id: number) => Promise<any>;
    getNews: () => Promise<any>;
    uploadChannel: (params: { customer: string; lob: string; user_id: string; date: string; channel: string; file?: File }) => Promise<any>;
}

export const AIRepositoryName = "AIRepositoryName";